<template>
    <div class="salary-edit-personneltab">
        <el-table :data="data.items" empty-text="無資料" size="small" class="salary-edit-table">
            <el-table-column prop="type" label="類型" width="200">
                <template slot-scope="scope">
                    <div class="row-title">
                        <span>{{ scope.row.type }}</span>
                        <ah-tip v-if="scope.row.tip != ''">{{ scope.row.tip }}</ah-tip>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="pamt" label="繳款單應繳金額" min-width="140">
                <template slot-scope="scope">
                    <el-form-item :prop="'forms[3].items[' + scope.$index + '].pamt'" :rules="rules.personnel_pamt">
                        <money-input :precision="0" v-model="scope.row.pamt" @change="updateAmts(scope.row)" style="width: 100%" />
                    </el-form-item>
                </template>
            </el-table-column>
            <el-table-column prop="date" label="付款日期" width="160">
                <template slot-scope="scope">
                    <el-form-item :prop="'forms[3].items[' + scope.$index + '].paY_DAT'" :rules="rules.paY_DAT">
                        <el-date-picker
                            v-model="scope.row.paY_DAT"
                            type="date"
                            value-format="timestamp"
                            placeholder="選擇日期"
                            style="max-width: 150px"
                            :disabled="scope.row.pamt == 0 || scope.row.pamt == null"
                            @change="onChangeDate(scope.row)"
                        >
                        </el-date-picker>
                    </el-form-item>
                </template>
            </el-table-column>
            <el-table-column prop="bank" label="付款帳戶" width="210">
                <template slot-scope="scope">
                    <el-form-item :prop="'forms[3].items[' + scope.$index + '].bnK_SNO'" :rules="rules.bnK_SNO">
                        <ah-el-select-bank-account
                            v-model="scope.row.bnK_SNO"
                            cny="TWD"
                            :disabled="scope.row.pamt == 0 || scope.row.pamt == null"
                            hide-borrower
                            allow-cash
                            document-type='salary'
                            @change="onChangeBank(scope.row)"
                        >
                        </ah-el-select-bank-account>
                    </el-form-item>
                </template>
            </el-table-column>
            <el-table-column prop="headcount" label="投保人數" min-width="80">
                <template slot-scope="scope">
                    <el-form-item>
                        <money-input v-model="scope.row.headcount" :precision="0" style="width: 100%" />
                    </el-form-item>
                </template>
            </el-table-column>
            <el-table-column prop="empSelfPay" label="員工自付額" min-width="100">
                <template slot-scope="scope">
                    <el-form-item>
                        <money-input v-if="scope.$index !== 0 && scope.$index !== 3" :value="scope.row.empSelfPay" :precision="0" style="width: 100%" disabled />
                    </el-form-item>
                </template>
            </el-table-column>
            <el-table-column prop="amt" label="公司負擔試算" min-width="130">
                <!-- 繳款單應繳金額 - 固定、非固定薪資代扣勞健保 -->
                <template slot-scope="scope">
                    <el-form-item>
                        <money-input :precision="0" v-model="scope.row.amt" :disabled="true" style="width: 100%" />
                    </el-form-item>
                </template>
            </el-table-column>
            <el-table-column prop="payroll" label="受僱者當月投保總金額" min-width="130">
                <template slot-scope="scope">
                    <el-form-item>
                        <money-input v-if="scope.$index < 3" v-model="scope.row.payroll" :precision="0" style="width: 100%" />
                    </el-form-item>
                </template>
            </el-table-column>


        </el-table>
        <ul class="memo-list">
            <!-- <li>可先預填未來應繳金額、付款日期、帳戶，實際收到繳款單時再回此月份編輯。</li>
            <li>推算繳款月份：退休金：三個月一次（1號）；勞保費：兩個月一次（1號）；健保費：兩個月一次（16號）</li> -->
            <li>健保補充保險費 ＝ 單位繳納（本月薪資總額 - 本月投保金額總額）* 費率</li>
            <li>本月薪資總額 ＝（固定薪資 ＋ 非固定薪資）</li>
        </ul>
        <el-form-item>
            <el-input :value="data.mem" type="textarea" :rows="4" placeholder="備註" style="margin-top: 15px" @input="val => onInput(val, 'mem')" :maxlength="200" :show-word-limit="true" />
        </el-form-item>
    </div>
</template>

<script>
import mixins from './mixins';

export default {
    mixins: [mixins],
    data() {
        return {
            name: 'personnelData',
        };
    },
    mounted() {
        console.log(this.data);
    },
};
</script>
<style lang="scss">
.salary-edit-personneltab {
    .memo-list {
        font-size: 10pt;
        padding: 25px;
    }
}
</style>
